<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <filter-layout
    title="추가 필터"
    sub-title="중복 선택이 가능합니다."
    :sub-title-style="{
      color: '#cccccc',
      'font-size': '1.2rem'
    }"
    padding-y="3rem"
    padding-x="3.2rem"
    width="67rem"
    :style="{ right: 0 }"
    class="option-filter"
    v-show="isShow"
  >
    <ul class="option-list">
      <li :class="{on: optionsFilter.is_elevator}" @click="toggleOptionsFilter('is_elevator')">
        <span class="option-name" >엘리베이터</span>
      </li>
      <li :class="{on: optionsFilter.is_parking}" @click="toggleOptionsFilter('is_parking')">
        <span class="option-name" >주차장</span>
      </li>
      <li :class="{on: optionsFilter.is_sprinkler}" @click="toggleOptionsFilter('is_sprinkler')">
        <span class="option-name">스프링쿨러</span>
      </li>
      <li :class="{on: optionsFilter.is_cctv}" @click="toggleOptionsFilter('is_cctv')">
        <span class="option-name" >CCTV</span>
      </li>
      <li :class="{on: optionsFilter.option_doorlock}" @click="toggleOptionsFilter('option_doorlock')">
        <span class="option-name" >방문 도어락</span>
      </li>
      <li :class="{on: optionsFilter.option_refrigerator}" @click="toggleOptionsFilter('option_refrigerator')">
        <span class="option-name" >개별 냉장고</span>
      </li>
      <li :class="{on: optionsFilter.option_tv}" @click="toggleOptionsFilter('option_tv')">
        <span class="option-name" >TV</span>
      </li>
      <li :class="{on: optionsFilter.option_internet}" @click="toggleOptionsFilter('option_internet')">
        <span class="option-name" >WI-FI</span>
      </li>
      <li :class="{on: optionsFilter.option_aircon}" @click="toggleOptionsFilter('option_aircon')">
        <span class="option-name" >개별 에어컨</span>
      </li>
      <li :class="{on: optionsFilter.option_wash}" @click="toggleOptionsFilter('option_wash')">
        <span class="option-name" >개별 세탁기</span>
      </li>
      <li :class="{on: optionsFilter.is_dry}" @click="toggleOptionsFilter('is_dry')">
        <span class="option-name" >건조기</span>
      </li>
      <li :class="{on: optionsFilter.is_double_room}" @click="toggleOptionsFilter('is_double_room')">
        <span class="option-name">2인실 보유</span>
      </li>
    </ul>
  </filter-layout>
</template>

<script>
  import FilterLayout from '../Layout/FilterLayout'
  import {mapState} from 'vuex'

  export default {
    name: 'OptionalFilter',
    components: {FilterLayout},
    props: {
      isShow: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {

      }
    },
    computed: {
      ...mapState({
        optionsFilter: state => state.FILTERS.OPTIONAL_FILTER
      })
    },
    methods: {
      toggleOptionsFilter (key) {
        this.$store.dispatch('toggleOptions', key)
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";

  .option-filter {
    ul {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      li {
        line-height: 4.65rem;
        font-weight: bold;
        border: 1px solid @very-light-pink-two;
        color: @brown-grey;
        box-sizing: border-box;
        flex: 1 0 20%;
        margin: 0.5rem;

        &.on {
          background-color: @windows-blue;
          color: @white;
          border: 1px solid @windows-blue;
        }
      }
    }
  }
</style>


<style scoped lang="less" >
  @import "../../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    .option-filter {
      ul {
        li {
          flex: 1 0 25%;
        }
      }
    }
  }
</style>
